"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

require("core-js/modules/es.array.concat.js");

require("core-js/modules/es.array.map.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _color = _interopRequireDefault(require("color"));

var _link = _interopRequireDefault(require("@meepshop/link"));

var _useColors = _interopRequireDefault(require("../../hooks/useColors"));

var _MenuItem = _interopRequireDefault(require("../largeMenu/MenuItem"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

require("./styles.less");

var styles = {
  "menuWrapper": "meepshop-meep-ui__submenu-largeMenuWithImage-styles__menuWrapper",
  "visible": "meepshop-meep-ui__submenu-largeMenuWithImage-styles__visible",
  "menu": "meepshop-meep-ui__submenu-largeMenuWithImage-styles__menu",
  "menuContent": "meepshop-meep-ui__submenu-largeMenuWithImage-styles__menuContent",
  "menuImage": "meepshop-meep-ui__submenu-largeMenuWithImage-styles__menuImage",
  "imageContainer": "meepshop-meep-ui__submenu-largeMenuWithImage-styles__imageContainer",
  "imageTextContainer": "meepshop-meep-ui__submenu-largeMenuWithImage-styles__imageTextContainer",
  "imageWrapper": "meepshop-meep-ui__submenu-largeMenuWithImage-styles__imageWrapper",
  "image": "meepshop-meep-ui__submenu-largeMenuWithImage-styles__image",
  "imageText": "meepshop-meep-ui__submenu-largeMenuWithImage-styles__imageText",
  "button": "meepshop-meep-ui__submenu-largeMenuWithImage-styles__button"
};

var MenuContent = function MenuContent(_ref) {
  var visible = _ref.visible,
      pages = _ref.pages,
      menuSettings = _ref.menuSettings,
      submenuSettings = _ref.submenuSettings;
  // 色彩配置
  var colors = (0, _useColors["default"])();
  var imageSettings = submenuSettings.imageSettings;
  var alignmentStyles = {
    TOP_LEFT: {
      justifyContent: 'flex-start',
      alignItems: 'flex-start',
      textAlign: 'left'
    },
    TOP_CENTER: {
      justifyContent: 'flex-start',
      alignItems: 'center',
      textAlign: 'center'
    },
    TOP_RIGHT: {
      justifyContent: 'flex-start',
      alignItems: 'flex-end',
      textAlign: 'right'
    },
    CENTER_LEFT: {
      justifyContent: 'center',
      alignItems: 'flex-start',
      textAlign: 'left'
    },
    CENTER: {
      justifyContent: 'center',
      alignItems: 'center',
      textAlign: 'center'
    },
    CENTER_RIGHT: {
      justifyContent: 'center',
      alignItems: 'flex-end',
      textAlign: 'right'
    },
    BOTTOM_LEFT: {
      justifyContent: 'flex-end',
      alignItems: 'flex-start',
      textAlign: 'left'
    },
    BOTTOM_CENTER: {
      justifyContent: 'flex-end',
      alignItems: 'center',
      textAlign: 'center'
    },
    BOTTOM_RIGHT: {
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      textAlign: 'right'
    }
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "".concat(styles.menuWrapper, " ").concat(visible ? styles.visible : ''),
    style: {
      '--submenu-font-size': menuSettings.submenuFontSize ? "".concat(menuSettings.submenuFontSize, "px") : '16px',
      '--submenu-color': 'var(--color-3)',
      '--submenu-image-color': imageSettings.color || 'var(--color-3)',
      '--submenu-background-color': 'var(--color-2)',
      '--submenu-background-color-hover': (0, _color["default"])(colors[1]).darken(0.05),
      pointerEvents: visible ? 'auto' : 'none'
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.menu
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.menuContent
  }, pages.map(function (page) {
    return /*#__PURE__*/_react["default"].createElement(_MenuItem["default"], {
      key: page.id,
      page: page,
      menuSettings: menuSettings,
      submenuSettings: submenuSettings
    });
  })), /*#__PURE__*/_react["default"].createElement(_link["default"], {
    href: imageSettings.href || '',
    target: imageSettings.newWindow ? '_blank' : '_self'
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.menuImage
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.imageContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.imageWrapper,
    style: {
      aspectRatio: imageSettings.ratio || '1 / 1'
    }
  }, /*#__PURE__*/_react["default"].createElement("img", {
    className: styles.image,
    src: imageSettings.url || require("@meepshop/images/lib/getImage")["default"]({
      stage: "https://img.meepstage.com/G2xnYcTrbibe-9gB-Rc_CUlcHHsAnsZOhx_yDw-pQcY/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvaW1hZ2VQbGFjZWhvbGRlci5wbmc",
      production: "https://img.meepshop.com/C-s_Ttjn9EPMAeIs6XW2dmL0u_j-5klrI_0lzACuORw/Z3M6Ly9pbWcubWVlcGNsb3VkLmNvbS9hc3NldHMvaW1hZ2VQbGFjZWhvbGRlci5wbmc"
    }),
    alt: imageSettings.alt || imageSettings.titleText
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: styles.imageTextContainer,
    style: _objectSpread({}, alignmentStyles[imageSettings.alignment])
  }, imageSettings.showTitle && /*#__PURE__*/_react["default"].createElement("h5", {
    className: styles.imageText,
    style: {
      fontSize: imageSettings.titleFontSize,
      fontWeight: imageSettings.titleBold ? 700 : 500
    }
  }, imageSettings.titleText), imageSettings.showButton && /*#__PURE__*/_react["default"].createElement("span", {
    className: styles.button,
    style: {
      fontSize: imageSettings.buttonFontSize
    }
  }, imageSettings.buttonText)))))));
};

var _default = MenuContent;
exports["default"] = _default;